// Vue
import Vue from 'vue'
import i18n from './i18n'
import App from './App'
// 核心插件
import d2Admin from '@/plugin/d2admin'
// store
import store from '@/store/index'

// 菜单和路由设置
import router from './router'
import {
	frameInRoutes
} from '@/router/routes'

//axios异步请求
import axios from 'axios'
Vue.prototype.$axios = axios

//vxe-table第三方表格
import XEUtils from 'xe-utils'
Vue.prototype.$XEUtils = XEUtils
Vue.prototype.$XPrint = VXETable.print
// import 'xe-utils'
import VXETable from 'vxe-table'

import 'vxe-table/lib/index.css'

//引入md5
import md5 from 'js-md5'
Vue.prototype.$md5 = md5

//引入aes加密组件
import cryptoJS from '@/libs/util.cryptoJS.js'
Vue.prototype.$cryptoJS = cryptoJS


//引入cookies组件
import util from '@/libs/util.js'
Vue.prototype.$util = util

 import Print from './plugin/print/Print'
Vue.use(Print)  

/* import Print from '../print'
//App.use(Print); // Vue3 注册插件
 Vue.use(Print);  // Vue2.x 注册插件 * */
//  import  Vant from 'vant'
//  import 'vant/lib/index.css'
 
//  Vue.use(Vant);

// 核心插件
Vue.use(d2Admin)
Vue.use(VXETable)

new Vue({
	router,
	store,
	i18n,
	render: h => h(App),
	created() {
		// 处理路由 得到每一级的路由设置
		this.$store.commit('d2admin/page/init', frameInRoutes)
		// 设置顶栏菜单
		//this.$store.commit('d2admin/menu/headerSet', menuHeader)
		// 设置侧边栏菜单		
		// this.$store.commit('d2admin/menu/asideSet', menuAside)		
		// 初始化菜单搜索功能
		//this.$store.commit('d2admin/search/init', menuHeader)
	},
	mounted() {
		// 展示系统信息
		this.$store.commit('d2admin/releases/versionShow')
		// 用户登录后,从持久化数据库加载一系列的设置.刷新页面也会触发
		this.$store.dispatch('d2admin/account/load')
		// 获取并记录用户 UA
		this.$store.commit('d2admin/ua/get')
		// 初始化全屏监听
		this.$store.dispatch('d2admin/fullscreen/listen')
	},

}).$mount('#app')


